import React from 'react';
import { NavLink } from 'react-router-dom';
import { Wallet } from 'lucide-react';
import { bottomNavIcon, splitBottomNav, useBottomNavItems } from '../lib/bottomNav';
// Panelden yazılan CSS'in tutunacağı sabit kimlikler (bkz. lib/domHooks.js):
// kimlik şemaya gömülmez, ortak sabitten okunur.
import { SHELL_IDS } from '../lib/domHooks';

/* Mobil/tablet gorunumde header navigasyonunun yerini alan sabit alt menu.
   Gezinme yuvalari panelden yonetilir (settings.mobile_bottom_nav); ortadaki
   yuvarlak buton sabittir: uyede para yatirma kisayolu, giris yapmamis
   ziyaretcide giris modali. */
const MobileBottomNav = ({
  onWalletClick, onMenuClick, menuOpen, loggedIn,
}) => {
  const items = useBottomNavItems();
  const { left, right } = splitBottomNav(items);
  const itemClass = ({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`;

  const renderItem = (item, index) => {
    const Icon = bottomNavIcon(item.icon);
    const key = `${item.type}-${item.url}-${index}`;
    if (item.type === 'menu') {
      return (
        <button
          key={key}
          type="button"
          onClick={onMenuClick}
          className={`mobile-nav-item ${menuOpen ? 'active' : ''}`}
          aria-expanded={menuOpen}
        >
          <Icon size={20} aria-hidden="true" />
          <span>{item.label}</span>
        </button>
      );
    }
    return (
      <NavLink key={key} to={item.url} end={item.url === '/'} className={itemClass}>
        <Icon size={20} aria-hidden="true" />
        <span>{item.label}</span>
      </NavLink>
    );
  };

  return (
    <nav id={SHELL_IDS.bottomBar} className="app-bottom-bar mobile-bottom-nav" aria-label="Alt menü">
      {left.map(renderItem)}

      <div className="mobile-nav-item mobile-nav-item--center">
        <button
          type="button"
          onClick={onWalletClick}
          className="mobile-nav-wallet"
          aria-label={loggedIn ? 'Para yatır' : 'Giriş yap'}
        >
          <Wallet size={22} aria-hidden="true" />
        </button>
      </div>

      {right.map(renderItem)}
    </nav>
  );
};

export default MobileBottomNav;
